import React from 'react';


const Marquee = () => {
  const Maeq = 'FREE SHIPPING! On purchase of Above Rs.1000*';

  return (
    <div className="marqueeContainer">
      <div className="marqueeContent">
        <p className="sparklyText">{Maeq}</p>
      </div>
    </div>
  );
};

export default Marquee;
